
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBeaconTowerConeDown as ObiBeaconTowerConeDownElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-beacon-tower-cone-down.js';
 
 
 

 
 export const ObiBeaconTowerConeDown = createComponent({
   react: React,
   tagName: 'obi-beacon-tower-cone-down',
   elementClass: ObiBeaconTowerConeDownElement,
   events: {
     
   }
  });
 
 